<template>
  <div class="tour-popup">
      <div id="modal_dashboard" class="modal left modal-dashbrd" role="dialog">
        <div class="modal-dialog modal-md">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="modal-header">
                        <div class="dashboard-heading">
                            <span v-if="currentTour.image">{{currentTour.type}}
                            </span>
                            <img src="/static/images/icons/virtualtour_close_icon.svg" class="close-icon" data-dismiss="modal" @click="closePopup"/>
                        </div>
                        <div
                         src="/static/images/dashboard/tour_banner.png"
                         :class="currentTour.type == 'Rastreador de Conformidade'?'compliance-header-swoop':'header-swoop'"
                       ></div>
                    </div>
                    <div>
                     <p class="dashbrd-txt" v-html="currentTour.title"></p>
                    </div>
                   <div class="list-item" v-html="currentTour.content">
                   </div>
                </div>
                <div class="modal-footer">
                    <div class="row tour-status">
                        <span v-for="index in tourObjectLength" :key="index" v-bind:class = "(tourIndex === (index - 1) )?'active-round-button':'round-button'"></span>
                        <span class="round-button"></span>
                    </div>
                    <div class="btn-next-div">
                      <div class="modal-arrow"
                       :style="[{
                         'border-color': `${currentTour.key === 9 ? 'transparent #4c9e45 transparent transparent' : ''}`,
                         'top': `${currentTour.key === 0 ? 21 : currentTour.clickValue}px`,
                        }]">
                      </div>
                      <button
                         type="button"
                         class="btn custom-btn blue-outline-back-button"
                         @click="previousTour()"
                         >
                       {{ $t('backButton') }}
                     </button>
                     <button
                         type="button"
                         class="btn custom-btn blue-color-next-button"
                         @click="playNextTour()"
                       >
                     {{ $t('next') }}
                     </button>
                   </div>
                </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import EventBus from '../../utils/event-bus';

export default {
  data() {
    return {
    };
  },
  props: ['roleId', 'displayRep', 'currentTour', 'playNextTour', 'previousTour', 'showSElink', 'tourObjectLength', 'tourIndex'],
  methods: {
    closePopup() {
      EventBus.$emit('tourEnd');
    },
  },
  computed: {
    clickValue() {
      let val = this.currentTour.clickValue;
      if (this.showSElink && this.currentTour.key > 9) {
        val += 45;
      }
      if ((this.roleId === 3 || this.roleId === 6) && this.currentTour.key > 2) {
        if (this.roleId === 6 && this.currentTour.key > 11) {
          val -= 90;
        } else {
          val -= 45;
        }
      }
      return `${val}px`;
    },
  },
};
</script>

<style scoped>
.compliance-header-swoop{
  width: 100%;
  max-height: 330px;
  border-radius: 5px 0px;
  height: 140px;
}
.tour-popup .modal.left .modal-content{
  height: 437px;
  width: 509px;
  overflow: auto;
}
.item-container{
  padding: 0px;
  margin: 0px;
}
.blue-outline-back-button,
.blue-outline-back-button:hover,
.blue-outline-back-button:focus {
    background-color: #E6E6E6;
    line-height: 24px;
    color: #404040;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    padding: 6px 16px;
    margin-right: 11px;
    height: 44px;
}
.blue-color-next-button, .blue-color-next-button:hover{
    background-color: #01518A;
    line-height: 25px;
    cursor: pointer;
    color: #ffffff !important;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    padding: 6px 16px;
    height: 44px;
}
.tour-popup .modal-dashbrd .modal-dialog {
  width: 463px;
  margin-top: 41px;
  left: 218px;
}
.tour-popup .close-icon {
  position: absolute;
  right: 23px;
  top: 6px;
  cursor: pointer;
}
.tour-popup .modal-header,
.tour-popup .modal-footer {
  background-color: transparent;
  border-top: none;
  display: flex;
}
.tour-popup .modal-header {
  border-bottom: 1px solid #D3D3D3;
  height: 60px;
  padding: 0px;
}
.dashboard-heading {
  /* position: absolute; */
  margin: 17px auto 16px 16px;
  left: 0;
  right: 0;
  text-align: left;
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
  color: #1A1A1A;
}
.modal-dashbrd .header-swoop {
  height: 100px;
}
.header-swoop {
  width: 100%;
  max-height: 330px;
  border-radius: 5px 0px;
}
.modal-arrow {
  content: '';
  display: block;
  position: fixed;
  top: 2%;
  bottom: auto;
  /* left: -83px; */
  left: -59px;
  width: 0;
  height: 0;
  border-style: solid;
  /* border-width: 22px 42px 22px 42px; */
  border-width: 20px 20px 18px 42px;
  border-color: transparent #ffffff transparent transparent;
}
.modal-dashbrd .modal-body {
  overflow-y: auto;
  /* height: 432px; */
  font-size: 15px;
  padding: 0px !important;
}
.dashbrd-txt {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  text-align: left;
  color: #000000;
  margin: 24px auto 16px 24px;
}
.tour-popup .btn-next-div {
  text-align: center;
}
.tour-popup .modal.left .modal-body,
.tour-popup .modal.right .modal-body {
  padding: 15px 15px 50px;
}
.tour-popup .description-txt {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
}
@media screen and (max-width: 767px) {
  .tour-popup {
    display: none;
  }
}
.disableBodyScroll {
  height: unset;
}

@media only screen and (max-width: 1300px) {
  .tour-popup .modal-dashbrd .modal-dialog {
    margin-top: 96px;
    left: 275px;
  }
  .modal-dashbrd .modal-body{
    height: 356px;
  }
  .disableBodyScroll {
    height: 100%;
  }
  .spinner {
    left: 0;
  }
  .spinnerTop {
    position: fixed;
    width: 100%;
    left: 0 !important;
    right: 0;
    top: 0;
    z-index: 1;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.7);
  }
}

.modal-content {
  border-radius: 10px;
  overflow: auto;
}
.modal.left .modal-body {
  max-height: fit-content !important;
}
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
::-webkit-scrollbar-thumb:hover {
  background: #D9D9D9;
}
::-webkit-scrollbar-track-piece:start {
  margin-top: 8px;
}
.description-txt {
  padding: 5px 15px 15px 15px;
}
.btn-next-div {
  display: flex;
}
.mr-16 {
  margin-right: 16px;
}
.tour-icon {
  width: 28px;
  margin-top: -4px;
  margin-right: 12px;
}
.list-item {
  display: list-item;
  margin-right: 11px;
  margin-left: 14px;
  list-style-type: none;
}
.list-item >>> sup {
  top: -0.1em;
  font-size: 100%;
}
.list-item >>> ul li{
  margin: 12px 0;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
}
.row{
  width: 100%;
  text-align: center;
  margin: -15px 0 30px;
}
.round-button, .active-round-button{
  width: 12.75px;
  height: 12.75px;
  border-radius: 50%;
  display: inline-block;
  float: none;
  border: 2px solid #4D4D4D;
  margin: 0 4px;
}
.active-round-button{
  background: #FFFFFF;
  background: radial-gradient(#00518A 0%, #00518A 46%, transparent 51%, transparent);
  border: 2px solid #00518A;
}
.modal.left .modal-footer, .modal.right .modal-footer{
  position: absolute;
  height: 76px;
}
.modal-footer {
  background-color: #FFFFFF;
  height: 83px;
  border-radius: 0 0 10px 10px;
}
.modal-footer .tour-status {
  height: 100%;
  display: flex;
  align-items: center;
  margin: 0;
}
@media screen and (max-width: 767px) {
  .modal-dashbrd {
    display: none !important;
  }
}
@media (min-width: 768px) {
  .modal-content {
    box-shadow: none !important;
  }
}
</style>
